import axios from 'axios';
import {
  GetPostsResult,
  Post,
  TrendingTopicPeriod,
} from 'common/interfaces/api';

import { MinimizedUserInfoType, PostItemType } from './timeline';
import { TopicType, UserTopicTypeWithPostCount } from './user';

export const getPostTopics = async () => {
  return (await axios.get(`/feeds/domains`)).data as {
    data: TopicType[];
  };
};

export enum TopicRelatedPostsTypeEnum {
  Recommend = 'recommend',
  Latest = 'latest',
  Prime = 'prime',
}

export type TrendingTopicKeyword = {
  topic: string;
  post_count: number;
  topic_type: string;
  posts: Post[];
};

export const getTrendingTopicKeywords = async (
  period: TrendingTopicPeriod,
  page: number,
) => {
  return (await axios.get(`/posts/topics/trending?type=${period}&page=${page}`))
    ?.data as {
    data: TrendingTopicKeyword[];
  };
};

export const getTrendingTopicPosts = async ({
  topic,
  page,
  period,
}: {
  topic: string;
  page: number;
  period: TrendingTopicPeriod;
}) => {
  return (
    await axios.get(
      `/posts/topics/posts?type=${period}&topic=${encodeURIComponent(
        topic,
      )}&page=${page}`,
    )
  )?.data as GetPostsResult;
};

// export const getLivePosts = async ({ page }: { page: number }) => {
//   return (await axios.get(`/feeds/lives?page=${page}`))?.data as GetPostsResult;
// };

export type TopicRelatedPostsResult = {
  data: {
    main_topic: UserTopicTypeWithPostCount;
    posts: PostItemType[];
    related_topics: UserTopicTypeWithPostCount[];
    top_contributors: MinimizedUserInfoType[];
    all_post_count: number;
    is_follow: boolean;
  };
};
export const getTopicRelatedPosts = async ({
  topic,
  page,
  type,
}: {
  topic: string;
  page: number;
  type: TopicRelatedPostsTypeEnum;
}) => {
  return (
    await axios.get(
      `/posts/topics/related_posts?topic_name=${encodeURIComponent(topic)}&type=${type}&page=${page}`,
    )
  )?.data as TopicRelatedPostsResult;
};
